import { createContext } from 'react';
import {
  CreateContractInput,
  CreateRentChargeInput,
  LeaseTermOption,
} from '@/graphql/generated';
import { Property, TenantSimpleListData } from '@/custom-types';

export type CreateContractContextActionsProps = {
  setLeaseTerm: (leaseTermOption: LeaseTermOption, startDate: Date, finishDate: Date | null) => void;
  setRentCharges: (rentCharges: CreateRentChargeInput[]) => void;
  setDayForExecuteCharges: (day: string) => void,
  setSigned: (isSigned: boolean) => void;
  setSecurityDeposit: (amount: number, receivedDate?: Date) => void;
  setLateFees: (lateFeeDays?: number, percentageOfRentFees?: number, fiatAmountFees?: number) => void;
  state: CreateContractInput;
  setButtonDisabled: () => void;
  setButtonEnabled: () => void;
  setUnities: (unitiesIds: string[]) => void;
  setProperty: (property: Property) => void;
  property: Property | null;
  setTenant: (tenant: TenantSimpleListData | null) => void;
  tenant: TenantSimpleListData | null;
  buttonState: boolean;
  setAutoGenerateRentCharge: (isAutoGenerateRentCharge: boolean) => void;
  setMonthlyChargeAmount: (monthlyChargeAmount: string) => void;
}

export const CreateContractContext = createContext<CreateContractContextActionsProps | null>(null)
